module.exports = __webpack_public_path__ + "img/tag_blue_oval.b2c7a4c6.svg";